/* globals angular */
(function() {
  'use strict';

  function ApiConfigCtrl ($mdToast, $state, $stateParams, $tour, Perfil) {
    var ctrl = this;
    ctrl.$onInit = function () {
      ctrl.configObj = {
        endPoint: 'https://api.mandae.com.br/v2/',
      };
      Perfil.getToken()
        .then(function(response){
          ctrl.packageHook = response.webhookColetaCriada;
          ctrl.trackingHook = response.rastreamentoWebhookUrl;
          ctrl.trackingHeaderKeyHook = response.chaveHeaderWebhook;
          ctrl.trackingHeaderValorHook = response.valorHeaderWebhook;
          ctrl.itemHook = response.webhookItemProcessado;
          ctrl.configObj.token = response.token;
          ctrl.configObj.customerId = response.customerId;
          ctrl.configObj.codigoPrefixoRastreamento = response.codigoPrefixoRastreamento;
        }, function(){
          console.log('Error: GET saveHooks service');
        });

      if ($stateParams.tour) {
        startTour();
      }
    };
    ctrl.onSubmit = function (form) {
      var itemHook = form.itemHook.$modelValue;
      var packageHook = form.trackingHook.$modelValue;
      var trackingHeaderKeyHook = form.trackingHeaderKeyHook.$modelValue;
      var trackingHeaderValorHook = form.trackingHeaderValorHook.$modelValue;
      // console.log(form);
      // return;
      // var packageHook = form.rastreamentoWebhookUrl.$modelValue;
      if (!itemHook && !packageHook) {
        $mdToast.show(
          $mdToast.simple()
          .textContent('Campos não podem ser vazios')
          .action('OK')
          .highlightAction(true)
          .highlightClass('md-accent')
        );
        return;
      }
      ctrl.isLoading = true;
      var params = {
        webhookItemProcessado: itemHook,
        rastreamentoWebhookUrl: packageHook,
        chaveHeaderWebhook: trackingHeaderKeyHook,
        valorHeaderWebhook: trackingHeaderValorHook
      };
      Perfil.saveHooks(params)
        .then(function(){
          ctrl.isLoading = false;
          $mdToast.show(
            $mdToast.simple()
              .textContent('Alterado com sucesso!')
          );
        }, function(){
          ctrl.isLoading = false;
          console.log('Error: POST saveHooks service');
        });
    };

    function startTour() {
      const steps = $tour.makeTour([
        {
          title: 'Conecte-se via API',
          text: 'Em alguns casos você pode utilizar a API da Mandaê para se conectar aos nossos serviços',
          attachTarget: () => document.querySelector('app-toolbar .mat-tab-link:nth-child(5)'),
          previous: {
            text: 'Voltar',
            action: (ev, ref) => {
              ref.close('to_previous_section');
              $state.go('integration', { tour: true });
            }
          },
          next: {
            text: 'Finalizar',
            action: (ev, ref) => {
              ref.close('to_next_section');
            },
          },
        },
      ]);

      $tour.start(steps).subscribe();
    }
  }

  angular
    .module('mandaeApp')
    .controller('ApiConfigCtrl', ApiConfigCtrl);
})();
